import {
	githubLightInit,
	githubLightStyle,
} from "@uiw/codemirror-theme-github";

// Keep the familiar GitHub syntax contrast while avoiding red error-like code.
const formulaSyntaxColors: Record<string, string> = {
	"#116329": "#2764ad",
	"#22863a": "#2764ad",
	"#d73a49": "#7456b8",
	"#b31d28": "#7456b8",
	"#cb2431": "#7456b8",
	"#e36209": "#386db8",
};

export const formulaCodeTheme = githubLightInit({
	settings: {
		background: "#f9fafb",
		foreground: "#344054",
		gutterBackground: "#f9fafb",
		gutterForeground: "#98a2b3",
	},
	styles: githubLightStyle.map((style) => ({
		...style,
		color:
			typeof style.color === "string"
				? (formulaSyntaxColors[style.color] ?? style.color)
				: style.color,
		backgroundColor:
			style.backgroundColor === "ffeef0"
				? "#eef4ff"
				: style.backgroundColor,
	})),
});
